import { Map } from "leaflet";

type AnimatedMap = Map & { _onZoomTransitionEnd(): void };
let installed = false;

export function installLeafletZoomTeardownGuard() {
  if (installed) return;
  installed = true;

  // Leaflet 1.9.4's 250 ms zoom fallback can run after remove() deletes
  // the map pane. stop() cancels fly/pan animations, but not this timer.
  // Keep the original zoom behavior while the pane exists. Recheck this
  // compatibility guard when upgrading Leaflet (SEN-007).
  const prototype = Map.prototype as AnimatedMap;
  const finishZoom = prototype._onZoomTransitionEnd;
  prototype._onZoomTransitionEnd = function () {
    if (!this.getPane("mapPane")) return;
    finishZoom.call(this);
  };
}
